import Api from "@/services/api";

const pesquisaNcmMixin = {
  methods: {
    async pesquisaNcmMatriz(dados) {
      const response = await new Api().post("Ncm/pesquisaNcmMatriz", dados, false, 500);
      return response;
    }
  }
};

export default pesquisaNcmMixin;
